<template>
    <DCard padding>
        <DRow>
            <DCol>
                <DTable
                    :key="tableKey"
                    :items="data"
                    :fields="fields"
                    hover
                >
                    <template #status="{item}">
                        <td>
                            <DTag
                                :label="__('contracts.contract_upload.statuses.' + item.status)"
                                :color="getStatusTagColor(item.status)"
                            />
                        </td>
                    </template>
                    <template #actions="{item}">
                        <td>
                            <div style="display: flex; grid-gap: 10px">
                                <DButton
                                    icon="eye"
                                    mini
                                    @click="preview(item.id)"
                                />
                                <DDropdown
                                    :id="`contract_upload_actions_dropdown_${item.id}`"
                                    :class="'more-actions-button'"
                                    :caret="false"
                                    icon="dots-horizontal"
                                >
                                    <DDropdownItem
                                        :id="`contract_upload_actions_download_file_${item.id}`"
                                        @click="downloadFile(item.id)"
                                    >
                                        {{ __('contracts.contract_upload.download_csv_file') }}
                                    </DDropdownItem>
                                </DDropdown>
                            </div>
                        </td>
                    </template>
                </DTable>
                <DPagination
                    v-if="files.last_page >= 1"
                    :active-page="files.current_page"
                    :pages="files.last_page"
                    align="center"
                    @update:activePage="changePage"
                />
            </DCol>
        </DRow>
        <DFabs>
            <DFab
                id="btn-preview-new-contract_upload"
                icon="plus"
                :label="__('contracts.contract_upload.upload')"
                @click="upload"
            />
        </DFabs>
    </DCard>
</template>
<script setup>
import { router, usePage } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'
import { __ } from '~@/Composables/translation'
import { onMounted, ref } from 'vue'

const props = defineProps({
    items: {
        type: Object,
        default: () => {
            return {}
        }
    },
    files: {
        type: Object,
        default: () => {
            return {}
        }
    }
})

onMounted(() => {
    window.laravelEcho.channel('onecrm.contracts.upload').listen('.contracts.upload_updated', socketEvent => {
        handleStatusUpdate(socketEvent)
    })
    data.value = props.items
})

const fields = [
    { key: 'id', label: __('contracts.contract_upload.headers.id') },
    { key: 'name', label: __('contracts.contract_upload.headers.name') },
    { key: 'date', label: __('contracts.contract_upload.headers.date') },
    { key: 'contracts', label: __('contracts.contract_upload.headers.contracts') },
    { key: 'employee', label: __('contracts.contract_upload.headers.employee') },
    { key: 'status', label: __('contracts.contract_upload.headers.status') },
    { key: 'actions', label: '', _style: { minWidth: '5%' } }
]

const tableKey = ref(0)
const data = ref([])
const upload = () => router.get(route('contracts.contract-upload.upload-page'))
const preview = (id) => router.get(route('contracts.contract-upload.show', id))

const changePage = (page) => {
    const query = {}
    if (page > 1) {
        query.page = page
    }

    router.get(route('contracts.contract-upload.index'), query)
}

const getStatusTagColor = (status) => {
    if (status === 'draft' || status === 'in_progress') {
        return 'primary'
    }
    if (status === 'open' || status === 'not_sent') {
        return 'secondary'
    }
    if (status === 'success' || status === 'sent') {
        return 'success'
    }
    return 'danger'
}

const downloadFile = (id) => {
    const link = document.createElement('a')
    link.href = route('contracts.contract-upload.download', id)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
}

const handleStatusUpdate = (socketEvent) => {
    // do something only if event came from same tenant
    if (socketEvent.tenant !== usePage().props.tenant) {
        return
    }

    const contractUpload = socketEvent.contractUpload
    const existingRequestId = data.value.findIndex(existingRequest => existingRequest.id === contractUpload.id)

    // remove highlight-row class from selected row after 3000ms
    setTimeout(() => {
        contractUpload._classes = ''
        data.value.splice(existingRequestId, 1, contractUpload)
        tableKey.value++
    }, 3000)

    contractUpload._classes = contractUpload.status === 'failed' ? 'highlight-row' : 'highlight-row-success'
    data.value.splice(existingRequestId, 1, contractUpload)
}

</script>
<style scoped lang="scss">

</style>
